import axios from 'axios';
const baseURL = "https://api.jesse.photo/api/";

const getCalendar = (year, month) =>{
    const request = axios.get(`${baseURL}calendar/?year=${year}&month=${month}`);
    return request.then(response => response.data);
}

export default { getCalendar }